
<template>
	<div>
		<div v-if="!isMobileCheck">
	    	<header class="lmy-header lmy-header-w">
		        <!-- <i class="iconfont icon-back"></i> -->
		        完成身份验证
		    </header>
		    <div class="lmy-change-phone">
		
		        <div class="title">首次登陆,请填写手机号码</div> 
		        <div class="new-mobile1">
		            <input type="text"  v-model="tel"  placeholder="输入手机号码">
		        </div>
		        <div class="new-mobile1">
		            <input type="text " v-model="Captcha" placeholder="输入右侧验证码">
		            <img :src="codeUrl" class="codeUrl" v-if="codeUrl" @click="getCodeUrl"/>
		        </div>
		        <div class="lmy-select-btn" @click="getCheckCode()" v-if="!isGettingCode">完成</div>        
		        <div class="lmy-select-btn"  v-if="isGettingCode">正在获取验证码</div>        
		    </div>
		</div>
		<div v-if="isMobileCheck">
			<header class="lmy-header lmy-header-w">
		        <i class="iconfont icon-back" @click="isMobileCheck=!isMobileCheck"></i>
		        完成身份验证
		    </header>
		    <div class="lmy-change-phone">
		        <div class="title">输入短信验证码</div> 
		        <div class="sub-title">验证码已发送至 {{tel}}</div>        
		        <div class="input-code-box">
		            <div :class="checkCodeArray[0]&&checkCodeArray[0]>=0?'box-item active':'box-item'"><input type="text" :value="checkCodeArray[0]"></div>
		            <div :class="checkCodeArray[1]&&checkCodeArray[1]>=0?'box-item active':'box-item'"><input type="text" :value="checkCodeArray[1]"></div>
		            <div :class="checkCodeArray[2]&&checkCodeArray[2]>=0?'box-item active':'box-item'"><input type="text" :value="checkCodeArray[2]"></div>
		            <div :class="checkCodeArray[3]&&checkCodeArray[3]>=0?'box-item active':'box-item'"><input type="text" :value="checkCodeArray[3]"></div>
		            <div :class="checkCodeArray[4]&&checkCodeArray[4]>=0?'box-item active':'box-item'"><input type="text" :value="checkCodeArray[4]"></div>
		            <div :class="checkCodeArray[5]&&checkCodeArray[5]>=0?'box-item active':'box-item'"><input type="text" :value="checkCodeArray[5]"></div>
		        </div> 
		        <div class="lmy-check-code-input">
		        	<input type="text" v-model="checkCode" maxlength="6" />
		        </div>
		        <div class="lmy-select-btn" @click="loginByCode()">完成</div>
		    </div>
		</div>
		<div class="book-comfirming" v-if="isSubmit">
		    <div class='f-modal' >
	            <div class='f-modal-head'>提示</div>
	            <div class='f-modal-body'>
	                <p>登录中</p>
	            </div>
	        </div>
	    </div>
	</div>






</template>
<script>
export default { 
	  data () {
	    return {
			isMobileLogin:false,
			isMobileCheck:false,
			isSubmit:false,
			isGettingCode:false,
			tel:'',
			checkCode:'',
			checkCodeArray:[],
			mobile:'',
			regDataToken:'',
			TraceKey:'',
			Captcha:'',
			codeUrl:'',
			title:'用户登录',
			loginType:'',
			lastPageUrl:localStorage.lastPageUrl,
			WXToken:this.dao.get('WXToken')||'',
			iswxCientOpen:true
	    }
	  },
	  watch:{
	  	tel(val,oldVal){
	  		if(val.length<oldVal.length){
	  			return;
	  		}
	  		var tel=val;
	  		if(tel.length==3){
	  			tel+=' ';
	  			this.tel=tel;
	  		}else if(tel.length==8){
				tel+=' ';
				this.tel=tel;
	  		}
	  	},
	  	checkCode(val){
	  		var list=val.split('');
	  		this.checkCodeArray=[];
	  		for(var i=0;i<list.length;i++){
	  			this.checkCodeArray[i]=list[i];
	  		}
	  	}
	  },
	  methods:{
		  	browserRedirect() {
				var system = { 
					win: false, 
					mac: false, 
					xll: false, 
					ipad: false
				}; 
				//检测平台  
				var p = navigator.platform; 
				system.win = p.indexOf("Win") == 0; 
				system.mac = p.indexOf("Mac") == 0; 
				system.x11 = (p == "X11") || (p.indexOf("Linux") == 0); 
				system.ipad = (navigator.userAgent.match(/iPad/i) != null) ? true : false; 
				//跳转语句，如果是手机访问就自动跳转到wap.baidu.com页面  
				if (system.win || system.mac || system.xll || system.ipad) { 
					this.$router.go(-6)
				} else { 
					var ua = navigator.userAgent.toLowerCase();  
					if(ua.match(/MicroMessenger/i)=="micromessenger") {  
						this.$router.go(-4)
					} else {  
						this.$router.push('/');
					}  
				}
			},
	  	    getCodeUrl(callback){
	  	    	this.Captcha='';
                let _this = this;
                this.getRequest({
                    url: this.Api.captcha + '?width=90&height=50'
                }).then(res => {
                    if (res) {
                        this.codeUrl = 'data:image/jpg;base64,'+res.Img;
                        this.regDataToken = res.Token;
                        this.TraceKey = res.TraceKey;
                    }
                });
            },
	  		getCheckCode(){
	  			var that=this;
	  			var tel=this.tel;
	  			tel=tel.replace(/\s/ig,'');
	  			if(!this.checkMobile(tel))return;
				if(!this.Captcha){
					this.error({title:'提示',content:'请输入图片验证码'});
					return;
				}
				var data ={
					"phone": tel,
					"Token": this.regDataToken,
					"Captcha": this.Captcha,
					"TraceKey": this.TraceKey,
				};
				that.isGettingCode=true;
				
				this.postRequest({
					url:this.Api.getSMS, 
					params:data
				}).then(res => {
					this.isGettingCode=false;
				    if(res&&res.IsSuccess){
				    	this.isMobileCheck=true;
				    }else{
				    	this.getCodeUrl();
				    	this.error({title:'验证码错误',content:res.Msg||'验证码错误，请重新输入'});
				    }
				});

	  		},
	  		//手机验证码登录
			loginByCode:function(){
				var that=this;
				var tel=this.tel;
	  			tel=tel.replace(/\s/ig,'');
				if(!this.checkCode){
					this.error({title:'登陆失败',content:'请输入验证码'});
					return;
				}

				var data ={
									"Mobile": tel,
	                "Code": this.checkCode,
	                "WXToken": this.WXToken,
	                "LoginType": "3"
				};

				that.isSubmit=true;

				this.postRequest({
					url:this.Api.smslogin,  
					params:data
				}).then(res => {
					that.isSubmit=false;
					if(res&&res.IsSuccess){
					    if(res.Result.AccessToken){
					    	this.error({title:'提示',content:'注册成功'});
					    	//登陆成功后，保存登陆信息到本地localstorage
					    	that.dao.set('userInfo',JSON.stringify(res.Result));
					    	this.dao.set('WXToken','');
							that.setHttpHeaders(res.Result.AccessToken);
						
							var url=this.dao.get('lastPageUrl')||'';
							this.browserRedirect()
					    	// if(url&&(url.indexOf("frHotelDetails")>-1||url.indexOf("hotelDetails")>-1||url.indexOf("presaleDetails")>-1||url.indexOf("packageDetails")>-1)){
					    	// 		that.$router.push(url);
					    	// 	}else{
					    	// 		that.$router.push('/');
					    	// }
					    }else{
					    	this.error({title:'提示',content:res.error_description||'登陆失败'});
					    }
					}
				});
			}

	  },
	  	mounted(){
			
			this.getCodeUrl();
		},

}
</script>



// WEBPACK FOOTER //
// src/components/usr/bindUserPhoneNumber.vue